// PayDirt API — Base fetch wrapper with silent 401 refresh

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://paydirt-delta-production.up.railway.app';

// Mutex: only one refresh at a time, all concurrent 401s wait for it
let refreshPromise = null;

async function refreshTokens() {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 8000);
  try {
    const res = await fetch(`${BACKEND_URL}/api/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
      signal: controller.signal,
    });
    return res.ok;
  } catch {
    return false;
  } finally {
    clearTimeout(timeout);
  }
}

export async function apiFetch(path, opts = {}) {
  const res = await fetch(`${BACKEND_URL}${path}`, { ...opts, credentials: 'include' });

  if (res.status !== 401) return res;

  // 401 — attempt silent refresh (once, with mutex)
  if (!refreshPromise) {
    refreshPromise = refreshTokens().finally(() => { refreshPromise = null; });
  }

  const refreshed = await refreshPromise;
  if (!refreshed) return res;

  // Retry original request with new cookie
  return fetch(`${BACKEND_URL}${path}`, { ...opts, credentials: 'include' });
}
